
import React from 'react';
import { Lead } from '@/components/leads/types';
import { DetailItem } from '../DetailItem';
import { EditableDetailItem } from '../EditableDetailItem';
import { Globe, Briefcase, Users, Building, MapPin, DollarSign, Phone } from 'lucide-react';

interface CompanyInformationSectionProps {
  lead: Lead;
  handleFieldSave: (leadId: string, fieldName: keyof Lead, value: any) => Promise<void>;
  isUpdatingLead: boolean;
}

export const CompanyInformationSection: React.FC<CompanyInformationSectionProps> = ({ lead, handleFieldSave, isUpdatingLead }) => {
  return (
    <div className="py-4">
      <h3 className="text-md font-semibold mb-3 text-gray-800 flex items-center"><Building size={18} className="mr-2 text-primary"/>Company Information</h3>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-1">
        <DetailItem
          icon={<Globe size={16} />} 
          label="Website" 
          value={lead.website || "N/A"}
          isLink={!!lead.website}
          linkHref={lead.website}
          linkText={lead.website ? "View Website" : undefined}
        />
        <EditableDetailItem
          icon={<Briefcase size={16} />}
          label="Industry"
          value={lead.industry}
          fieldName="industry"
          leadId={lead.id}
          onSave={handleFieldSave}
          inputType="text"
          isLoading={isUpdatingLead}
        />
        <EditableDetailItem 
          icon={<Users size={16} />} 
          label="Company Size" 
          value={lead.size_range} 
          fieldName="size_range"
          leadId={lead.id}
          onSave={handleFieldSave}
          inputType="text"
          isLoading={isUpdatingLead}
        />
        <EditableDetailItem
          icon={<Phone size={16} />}
          label="Corporate Phone"
          value={lead.corporate_phone}
          fieldName="corporate_phone"
          leadId={lead.id}
          onSave={handleFieldSave}
          inputType="text"
          isLoading={isUpdatingLead}
        />
        <EditableDetailItem 
          icon={<MapPin size={16} />} 
          label="Geographic Area" 
          value={lead.geographic_area}
          fieldName="geographic_area"
          leadId={lead.id}
          onSave={handleFieldSave}
          inputType="text"
          isLoading={isUpdatingLead}
        />
        <EditableDetailItem 
          icon={<DollarSign size={16} />} 
          label="Revenue Range" 
          value={lead.revenue_range}
          fieldName="revenue_range"
          leadId={lead.id}
          onSave={handleFieldSave}
          inputType="text"
          isLoading={isUpdatingLead}
        />
      </div>
    </div>
  );
};
